/**
 * Presentation-only labels for supplier category codes.
 *
 * The original value from the provider is never modified nor stored: this
 * helper is used exclusively when rendering, so the customer never sees
 * technical codes such as `BUS_OR_MINAV_TOUR` or `LUXURY_AND_SPECIAL_OCCASIONS`.
 */
const KNOWN: Record<string, string> = {
  BUS_OR_MINAV_TOUR: "Tour en transporte",
  BUS_OR_MINIVAN_TOUR: "Tour en transporte",
  LUXURY_AND_SPECIAL_OCCASIONS: "Lujo y ocasiones especiales",
  CULINARY: "Gastronomía",
  CULTURAL_TOUR: "Cultura",
  CULTURE: "Cultura",
  ADVENTURE: "Aventura",
  DAY_TRIP: "Excursión de un día",
  DAY_TRIPS: "Excursiones de un día",
  PRIVATE_TOUR: "Tour privado",
  WALKING_TOUR: "Tour a pie",
  BOAT_TOUR: "Paseo en barco",
  SNORKELING: "Esnórquel",
  DIVING: "Buceo",
  WATER_SPORTS: "Deportes acuáticos",
  NATURE_AND_WILDLIFE: "Naturaleza y vida silvestre",
  SIGHTSEEING: "Recorridos turísticos",
  ARCHAEOLOGICAL: "Arqueología",
  FAMILY_FRIENDLY: "Para toda la familia",
  TRANSFER: "Traslados",
  AIRPORT_TRANSFER: "Traslado al aeropuerto",
  SHOW_OR_EVENT: "Espectáculos y eventos",
  WELLNESS: "Bienestar",
  MULTI_DAY_TOUR: "Varios días",
};

/** Human label for a category value. Falls back to a readable version. */
export function categoryLabel(raw: string): string {
  const key = raw.trim().toUpperCase().replace(/[\s-]+/g, "_");
  const known = KNOWN[key];
  if (known) return known;
  // Unknown technical-looking code (ALL_CAPS_WITH_UNDERSCORES) → readable text.
  if (/^[A-Z0-9_]+$/.test(raw.trim()) && raw.includes("_")) {
    const words = raw.trim().toLowerCase().split("_").filter(Boolean);
    const text = words.join(" ");
    return text.charAt(0).toUpperCase() + text.slice(1);
  }
  return raw;
}
